import {includes} from 'lodash'

import {europeCountries} from '../../../common/utils/uioptions'
import {config} from '../../../config'

/**
 * PT-7172: EU solicitation consent is required on registration when the client
 * picks an EU country and the white-label has not disabled solicitation.
 */
export const requiresEuSolicitationConsent = (country?: string | null): boolean => {
  if (!country) return false
  if (config.solicitationAcceptanceDisabled) return false
  return includes(europeCountries, country)
}
